// Quotation CustomerReview Stage  Btn related codes goes here

// NPM Imports
import React, { Fragment } from "react";

// Components Imports
import ExportDocumentBtn from "../../QuotationTopbar/QuotationTopbarBtns/ExportDocumentBtn";

// Declarations

export default function QuotationCustomerReviewBtns(props) {
  return (
    <Fragment>
      <ExportDocumentBtn docStatus={props.docStatus} />
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV2/QuotationTopBarBtns/QuotationCustomerReviewBtns.js